import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { AiFillFolder } from "react-icons/ai";
import { toastMessage } from '../utils/toast';
import * as formActions from '../../Redux/Actions/form';
import Warning from '../Ui/400';
import { ContainerOuter, LoaderContainer } from '../Mapping/styles';
import { clearSession } from '../utils/initiate';
import AamerLoader from '../Ui/Loader';

const DocumentVault = ({history}) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    
    useEffect(() => {
        setLoading(true);
        formActions.listAllUserContainers().then(res => {
            if(res && res.data){
                setData(res.data);
            }else{
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the user containers`);
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    }, [dispatch, history]);

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <>
            <ContainerOuter>
                    {loading ? <LoaderContainer><AamerLoader /></LoaderContainer>
                        : <div className="p-12">
                            <h4>Document Vault</h4>
                                <div className="d-flex flex-wrap my-4">
                                    {data.map(({userId, folderName}, index) => <div key={index} onClick={() => history.push(`/document-vault/${userId}`)} className="document-container p-4 font-weight-bold my-4 mr-10">
                                        <AiFillFolder className="icon-xl mr-4" />
                                        {folderName}
                                    </div>)}
                                </div>
                        </div>
                    }
            </ContainerOuter>
        </>
    )
};

export default DocumentVault;